<template>
    <div>
        <div class="TTL-el-form-search-regular">
            <el-form inline="true">
                <el-form-item>
                    <wcinput
                        :value="searchForm.keyword"
                        :option="{
                            placeholder: '请输入图标名称或标识',
                            clearable: true,
                            width: '250px',
                            ischange: true,
                            iskeydown: true
                        }"
                        @finish="handleKeywordInput"
                    />
                </el-form-item>
                <el-form-item>
                    <wcbutton :option="{ title: '搜索' }" @finish="handleSearch" />
                </el-form-item>
                <el-form-item>
                    <wcbutton :option="{ title: '新增图标' }" @finish="openAddDialog" />
                </el-form-item>
            </el-form>
        </div>

        <div class="TTL-table top20" :id="'table-system-image'" :ref="name">
            <el-table :data="tableData" stripe="true" empty-text="">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column label="图标" align="center" min-width="100">
                    <template #default="scope">
                        <wcimage :value="scope.row.thumb" :option="{ size: 'middle', showBig: true }" />
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name" align="center" min-width="140" />
                <el-table-column label="标识" prop="setting_key" align="center" min-width="160" />
                <el-table-column label="操作" align="center" min-width="200" fixed="right">
                    <template #default="scope">
                        <div class="TTL-btn-list">
                            <wcbutton class="right10" :option="{ title: '编辑' }" @finish="openEditDialog(scope.row)" />
                            <wcbutton :option="{ title: '删除', type: 'del' }" @finish="handleDelete(scope.row)" />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="TTL-page-box top20">
            <div class="TTL-page-box-in">
                <div class="TTL-page TTL-page-right">
                    <wcpage
                        :row="searchForm.rows"
                        :p="searchForm.p"
                        :rollpage="searchForm.rollpage"
                        @finish="(val) => {
                            searchForm.p = val.p;
                            searchForm.rollpage = val.rollpage;
                            getIconList();
                        }"
                    />
                </div>
            </div>
        </div>

        <el-dialog
            v-model="dialogVisible"
            class="system-icon-dialog"
            :title="isEdit ? '编辑系统图标' : '新增系统图标'"
            width="480px"
            append-to-body
            :close-on-click-modal="false"
            @closed="onDialogClosed"
        >
            <div class="add-cate-form">
                <div class="form-item">
                    <div class="form-label">图标名称</div>
                    <div class="form-control">
                        <wcinput
                            :value="form.name"
                            :option="{
                                placeholder: '请输入图标名称',
                                type: 'input',
                                clearable: true,
                                width: '280px',
                                ischange: true
                            }"
                            @finish="(payload) => { form.name = payload && payload.value !== undefined ? payload.value : ''; }"
                        />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">图标标识</div>
                    <div class="form-control">
                        <wcinput
                            :value="form.setting_key"
                            :option="{
                                placeholder: '请输入唯一标识 setting_key',
                                type: 'input',
                                clearable: true,
                                width: '280px',
                                ischange: true
                            }"
                            @finish="(payload) => { form.setting_key = payload && payload.value !== undefined ? payload.value : ''; }"
                        />
                    </div>
                </div>
                <div class="form-item form-item-upload">
                    <div class="form-label">图标图片</div>
                    <div class="form-control">
                        <wcupload
                            :value="form.thumb"
                            :option="{ size: 'middle', returnsize: 'middle', phototype: 'system' }"
                            @finish="(val) => { form.thumb = val && val.url ? val.url : ''; }"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="TTL-btn-list dialog-footer">
                    <wcbutton :option="{ title: '取消', type: 'del' }" @finish="dialogVisible = false" />
                    <wcbutton :option="{ title: '提交' }" @finish="submitForm" />
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import INTERFACE_SYSTEM_IMAGE from '@/Interface/systemimage.js';

export default {
    name: 'SystemImage',
    data() {
        return {
            name: 'SystemImage',
            searchForm: {
                keyword: '',
                p: 1,
                rows: 0,
                rollpage: 20,
            },
            tableData: [],
            dialogVisible: false,
            isEdit: false,
            form: {
                id: '',
                name: '',
                setting_key: '',
                thumb: '',
            },
        };
    },
    mounted() {
        this.OnloadMethod();
    },
    methods: {
        OnloadMethod() {
            this.getIconList();
        },
        BrotherComponentIn() {
            this.getIconList();
        },
        handleKeywordInput(payload) {
            this.searchForm.keyword = payload && payload.value !== undefined ? payload.value : '';
            if (payload && payload.type === 'keydown') this.handleSearch();
        },
        handleSearch() {
            this.searchForm.p = 1;
            this.getIconList();
        },
        async getIconList() {
            const obj = this.$refs[this.name];
            try {
                if (obj) this.$loading.openloading(obj);
                const res = await INTERFACE_SYSTEM_IMAGE.GET_SYSTEM_IMAGE_LIST({
                    keyword: this.searchForm.keyword || '',
                    p: this.searchForm.p || 1,
                    rollpage: this.searchForm.rollpage || 10,
                });
                if (obj) this.$loading.closeloading(obj);
                if (res && res.status > 0) return;
                const d = res && res.data;
                this.tableData = d && Array.isArray(d.list) ? d.list : [];
                this.searchForm.rows = d && Number(d.count) >= 0 ? Number(d.count) : 0;
            } catch (e) {
                if (obj) this.$loading.closeloading(obj);
                this.$notice({ title: '错误', message: '获取图标列表失败', type: 'error' });
            }
        },
        openAddDialog() {
            this.resetForm();
            this.dialogVisible = true;
        },
        openEditDialog(row) {
            if (!row || !row.id) return;
            this.resetForm();
            this.isEdit = true;
            this.form.id = row.id;
            this.form.name = row.name || '';
            this.form.setting_key = row.setting_key || '';
            this.form.thumb = row.thumb || '';
            this.dialogVisible = true;
        },
        resetForm() {
            this.isEdit = false;
            this.form = { id: '', name: '', setting_key: '', thumb: '' };
        },
        onDialogClosed() {
            this.resetForm();
        },
        submitForm() {
            const name = String(this.form.name || '').trim();
            const settingKey = String(this.form.setting_key || '').trim();
            const thumb = String(this.form.thumb || '').trim();
            if (!name) {
                this.$notice({ title: '提示', message: '请输入图标名称', type: 'warning' });
                return;
            }
            if (!settingKey) {
                this.$notice({ title: '提示', message: '请填写图标标识', type: 'warning' });
                return;
            }
            if (!thumb) {
                this.$notice({ title: '提示', message: '请上传图标图片', type: 'warning' });
                return;
            }
            this.isEdit ? this.doEdit() : this.doAdd();
        },
        async doAdd() {
            const res = await INTERFACE_SYSTEM_IMAGE.ADD_SYSTEM_IMAGE({
                name: String(this.form.name).trim(),
                setting_key: String(this.form.setting_key).trim(),
                thumb: String(this.form.thumb).trim(),
            });
            if (res && res.status > 0) return;
            this.$notice({ title: '成功', message: '新增成功', type: 'success' });
            this.dialogVisible = false;
            this.getIconList();
        },
        async doEdit() {
            const res = await INTERFACE_SYSTEM_IMAGE.EDIT_SYSTEM_IMAGE({
                id: this.form.id,
                name: String(this.form.name).trim(),
                setting_key: String(this.form.setting_key).trim(),
                thumb: String(this.form.thumb).trim(),
            });
            if (res && res.status > 0) return;
            this.$notice({ title: '成功', message: '保存成功', type: 'success' });
            this.dialogVisible = false;
            this.getIconList();
        },
        handleDelete(row) {
            if (!row || !row.id) return;
            this.$confirm
                .confirm('确定要删除该图标吗？删除后不可恢复。', '删除提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                .then(async () => {
                    const res = await INTERFACE_SYSTEM_IMAGE.DEL_SYSTEM_IMAGE({ id: row.id });
                    if (res && res.status > 0) return;
                    this.$notice({ title: '成功', message: '删除成功', type: 'success' });
                    this.getIconList();
                })
                .catch(() => {});
        },
    },
};
</script>

<style scoped>
.add-cate-form {
    display: block;
    width: 100%;
}
.form-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.form-item:last-child {
    margin-bottom: 0;
}
.form-label {
    flex-shrink: 0;
    width: 80px;
    margin-right: 10px;
    font-size: 13px;
    color: #333;
}
.form-control {
    flex: 1;
}
.form-item-upload {
    align-items: flex-start;
}
.dialog-footer {
    justify-content: flex-end;
    column-gap: 10px;
}
.TTL-btn-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
}
</style>
